import Title from '@cohort/components-xps/components/Title';
import SecondaryButton from '@cohort/wallet/components/button/SecondaryButton';
import {AboutBrand} from '@cohort/wallet/components/space/AboutBrand';
import DigitalAssetList from '@cohort/wallet/components/space/DigitalAssetList';
import JourneysList from '@cohort/wallet/components/space/JourneysList';
import PerksList from '@cohort/wallet/components/space/PerksList';
import useScreenSizeContext from '@cohort/wallet/hooks/useScreenSize';
import useSpaceContext from '@cohort/wallet/hooks/useSpaceContext';
import SpacePage from '@cohort/wallet/layouts/space/SpacePage';
import {
  getDigitalAssetsListRoute,
  getJourneysListRoute,
  getPerksListRoute,
} from '@cohort/wallet/lib/Pages';
import React, {Fragment} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

const HomePage: React.FC = () => {
  const {space, setTransitioning} = useSpaceContext();
  const {isMobile} = useScreenSizeContext();
  const {t} = useTranslation('pages', {keyPrefix: 'space.homePage'});
  const navigate = useNavigate();

  if (space === undefined) {
    return <Fragment />;
  }
  const digitalAssetsCount = space.pendingOrders.length + space.activeOwnerships.length;

  return (
    <Fragment>
      <SpacePage
        title={t('pageTitle')}
        tracking={{
          namespace: 'home',
        }}
        leftPanel={<AboutBrand />}
      >
        <div className="space-y-8">
          {isMobile && <AboutBrand />}
          <div>
            <Title
              content={
                <div className="flex justify-between">
                  <span>{t('journeysTitle')}</span>
                  {space.journeys.length > 0 && (
                    <SecondaryButton
                      size="small"
                      text={t('viewAll')}
                      onClick={() => {
                        setTransitioning({active: true, enterFrom: 'right'});
                        navigate(getJourneysListRoute());
                      }}
                      tracking={{namespace: 'journeys.list.viewAll'}}
                    />
                  )}
                </div>
              }
              classes="text-2xl mb-4"
            />
            <JourneysList campaigns={space.journeys.slice(0, 4)} />
          </div>
          <div>
            <Title
              content={
                <div className="flex justify-between">
                  <span>{t('digitalAssetTitle')}</span>
                  {digitalAssetsCount > 0 && (
                    <SecondaryButton
                      size="small"
                      text={t('viewAll')}
                      onClick={() => {
                        setTransitioning({active: true, enterFrom: 'right'});
                        navigate(getDigitalAssetsListRoute());
                      }}
                      tracking={{namespace: 'digitalAssets.list.viewAll'}}
                    />
                  )}
                </div>
              }
              classes="text-2xl mb-4"
            />
            <DigitalAssetList
              displayMode="carousel"
              pendingOrders={[]}
              ownerships={space.activeOwnerships.slice(0, 3)}
            />
          </div>

          <div>
            <Title
              content={
                <div className="flex justify-between">
                  <span>{t('perksTitle')}</span>
                  {space.perks.length > 0 && (
                    <SecondaryButton
                      size="small"
                      text={t('viewAll')}
                      onClick={() => {
                        setTransitioning({active: true, enterFrom: 'right'});
                        navigate(getPerksListRoute());
                      }}
                      tracking={{namespace: 'perks.list.viewAll'}}
                    />
                  )}
                </div>
              }
              classes="text-2xl mb-4"
            />
            <PerksList
              perks={space.perks
                .filter(
                  p =>
                    p.instances.filter(
                      access => access.canBeUsed || access.raffleStatus === 'pending'
                    ).length > 0
                )
                .slice(0, 3)}
              displayMode="carousel"
            />
          </div>
        </div>
      </SpacePage>
    </Fragment>
  );
};

export default HomePage;
